export enum LoginStatus {
  Logged = 'Logged',
  NotLogged = 'NotLogged',
  NotFinalized = 'NotFinalized',
}
